module.exports = __webpack_public_path__ + "img/logo-windows-xp.2e8dc238.png";